import { useEnvConfigStore } from "@/store/env.store";
import axios from "axios";

export default class ChatWootClientApiServices {
  envConfigStore= useEnvConfigStore()
  async postMethod(url: string, data: any={}) {
    const baseUrl = process.env.NODE_ENV == 'production' ? this.envConfigStore.aiChatBotKeys?.LiveChatUrl  :'/chatwootapi/'
    url = baseUrl + `public/api/v1/inboxes/${this.envConfigStore.aiChatBotKeys?.LiveChatInboxIdentifier}/` + url;
    try {
      const response = await axios({
        method: "post",
        // headers: {
        //   "Content-Type": "application/json; charset=utf-8",
        // },
        url,
        data,
      });
      return response.data;
    } catch (err: any) {
      return err.response;
    }
  }

  async getMethod(url: string, data: any={}) {
    const baseUrl = process.env.NODE_ENV == 'production' ? this.envConfigStore.aiChatBotKeys?.LiveChatUrl  :'/chatwootapi/'
    url = baseUrl + `public/api/v1/inboxes/${this.envConfigStore.aiChatBotKeys?.LiveChatInboxIdentifier}/` + url;
    try {
      const response = await axios({
        method: "get",
        // headers: {
        //   "Content-Type": "application/json; charset=utf-8",
        // },
        url,
        params:data,
      });
      return response.data;
    } catch (err: any) {
      return err.response;
    }
  }
}
